export const OutreachCallStatus = {
  CREATED: 'CREATED',
  SCHEDULED: 'SCHEDULED',
  SUCCESSFUL: 'SUCCESSFUL',
  FAILED: 'FAILED',
  NO_ANSWER: 'NO_ANSWER',
  RESCHEDULED: 'RESCHEDULED',
  DECLINED: 'DECLINED',
  CANCELED: 'CANCELED',
} as const;
export type OutreachCallStatus = (typeof OutreachCallStatus)[keyof typeof OutreachCallStatus];

export type TOutreachCandidate = {
  id: string;
  createdAt?: Date;
  firstName: string;
  lastName: string;
  clientId: string;
  campaignId: string;
  email: string;
  phone: string;
  qualifiedAt: boolean;
  language: string;
  qualificationStatus?: 'QUALIFIED' | 'NOT_QUALIFIED' | 'PENDING';
  screeningScore?: number | null;
  csatScore?: number | null;
  csatComment?: string | null;
  callStatus?: OutreachCallStatus;
  status?: string;
  activityLog?: {
    actionType: string;
    actionSubtype: string;
    type?: string;
    templateId?: string;
    isSuccess: boolean;
    createdAt: string;
    reason?: string;
    tags?: string[];
    status?: string;
    message?: string;
    metadata?: {
      oldStatus?: string;
      newStatus?: string;
    } & Record<string, unknown>;
  }[];
  lastContact?: string;
  callDuration?: number;
};
